export default __webpack_public_path__ + "static/media/ConveyorLiftMK1.256.240275fd.png";